module.exports = __webpack_public_path__ + "img/icon-tipo-trabajo.1ee8782f.svg";